<template>
  <div>
    <HotSite v-if="site === 'courses'" />
    <HomeView v-else />
  </div>
</template>

<script>
import HomeView from "@/views/HomeView.vue";
import HotSite from "@/views/HotSite.vue";

export default {
  name: "MainComponent",
  components: {
    HomeView,
    HotSite,
  },
  data() {
    return {
      site: "main",
      url: "",
    };
  },
  mounted() {
    if (process?.env?.VUE_APP_SITE) {
      this.site = process?.env?.VUE_APP_SITE;
    }
    this.url = window?.location?.host;
  },
};
</script>
